// extracted by mini-css-extract-plugin
module.exports = {"loading-overlay":"_7ca7f8b","loading-spinner":"_84550a5","spin":"_4070601"};